import {
    CLEAR_FAQ_LIST,
    GET_FAQ_LIST,
    SEARCH_FAQ,
    SET_ACTIVE_FAQ_TYPE,
    SET_FAQ_LIST,
} from "./availableActions";
import {
    ClearFaqListAction,
    GetFaqListAction,
    SearchFaqAction,
    SetActiveFaqTypeAction,
    SetFaqListAction,
} from "../../interfaces/store/actions/faq";
import {Faq} from "../../interfaces/store/actions/payload/faq";

export const getFaqList = (): GetFaqListAction => ({
    type: GET_FAQ_LIST,
});

export const clearFaqList = (): ClearFaqListAction => ({
    type: CLEAR_FAQ_LIST,
});

export const searchFaq = (payload: string): SearchFaqAction => ({
    type: SEARCH_FAQ,
    payload,
});

export const setFaqList = (payload: Faq[]): SetFaqListAction => ({
    type: SET_FAQ_LIST,
    payload,
});

export const setActiveFaqType = (payload: string): SetActiveFaqTypeAction => ({
    type: SET_ACTIVE_FAQ_TYPE,
    payload,
});
